import CryptoJS from 'crypto-js'
import JSEncrypt from 'jsencrypt'
import { Base64 } from 'js-base64'

// Base64 URL 编码 → 标准 Base64
function base64UrlToBase64 (base64Url) {
  let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const padLength = (4 - (base64.length % 4)) % 4
  base64 += '='.repeat(padLength)
  return base64
}

function base64UrlEncodeFromBase64 (base64String) {
  // 1. 替换 '+' 为 '-'
  let urlSafeBase64 = base64String.replace(/\+/g, '-')
  // 2. 替换 '/' 为 '_'
  urlSafeBase64 = urlSafeBase64.replace(/\//g, '_')
  return urlSafeBase64
}

const serverPublicKey = '-----BEGIN PUBLIC KEY-----\n' +
 base64UrlToBase64('MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAoLxYsyW3rKmSZlXOz9Ebe93Ep9EohfA93ZYCUocIL40TPLo35vhhnI0BBN0-KYzgehKPq_otoUJOEBI607qv7gt9FHvupPUxTiMhAih5k8OYVL_OxJlpsxpoIoXuwmwRjjfMUHAUXhDu2ztsSQM4Z9tajas-Ejf9VPXEvPWSBTkqR4WiCsQOYlgnaZAjqhRpz3l1x_D9enzsrgBoQB__dV9s4JE7TO871QMfbYRzjeqjfSkx7TXeLdU_Nrx_rdblBdPw-LbNYdjeRWIKS5_dnGRmLkJ52NQLGhAsMUPSi6sb_E7c7DP5PBRazANfo5ogJ1IOSv3XKIfS8ezfOjGyEQIDAQAB') +
 '\n-----END PUBLIC KEY-----'

const logPublicKey = '-----BEGIN RSA PUBLIC KEY-----\n' +
    'MIIBCgKCAQEAtchJ1nlkTsC6Ru0kSSLUMi9shGwRZPiud8WIn113+e7PyK/XyaNaEUeRcefyFEXUuWcJZRZscmyU2zpnjQWGvZCp9n0RasHqoKgfvnZIK7YgHPlYi3S1waBazTZcBM64O+K58NnfGi1l5rBL72imJJfW8CY3M9jFHOD8EmYH05KuogW8jyI8L8imJt55Bmjw7E9uHYbdbgJmI+vqN7L5ufR0XzifYJ7TUS0I8/UGIVznjs/OE8yzXg/fS83WOgvT3iiRxWQ6+YZcpa24BcWFG6ZiNY+do/WbgyTbYToyexd7W3eE8UsBxGNyraui0sDHNNHp5rHsNKZBDGwbQzZESwIDAQAB' +
    '\n-----END RSA PUBLIC KEY-----'

// 随机生成数字
export const createRandomNumber = (num) =>
  Array.from({ length: num }, () => Math.floor(Math.random() * 10)).join('')

// aes加密业务参数params
const encodeParams = (params, aesKey) => {
  /* 第一种：
  const key = CryptoJS.enc.Utf8.parse(aesKey)
  const iv = CryptoJS.enc.Utf8.parse(aesKey) */
  /* 第二种：
  const aesKeyBytes = CryptoJS.enc.Base64.parse(aesKey)
  const key = CryptoJS.lib.WordArray.create(aesKeyBytes.words, aesKeyBytes.sigBytes)
  const ivBytes = CryptoJS.lib.WordArray.create(aesKeyBytes.words)
  const iv = CryptoJS.lib.WordArray.create(ivBytes.words, ivBytes.sigBytes) */
  /* 第三种：
  const key = CryptoJS.enc.Base64.parse(aesKey)
  const iv = key.clone()
  iv.sigBytes = 16 */
  const key2 = CryptoJS.enc.Base64.parse(aesKey)
  const iv = CryptoJS.lib.WordArray.create(key2.words)
  const key = CryptoJS.lib.WordArray.create(key2.words, key2.sigBytes)
  const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(JSON.stringify(params)), key, {
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
    iv: iv
  })
  return encrypted.ciphertext.toString(CryptoJS.enc.Hex).toLowerCase()
}

// 生成加密的aesKey
const createEncryptAesKey = (publicKey, aesKey, isLog) => {
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(publicKey)
  return isLog ? encryptor.encrypt(aesKey) : base64UrlEncodeFromBase64(encryptor.encrypt(aesKey))
}

export const handleGetEncodeRequestParams = (params) => {
  const result = {
    timestamp: Date.now(),
    flowNo: createRandomNumber(10),
    params: '',
    key: '',
    secretKeyAesKey: ''
  }
  const key = createRandomNumber(16)
  const aesKey = Base64.encodeURI(key) // 生成 aeskey
  result.params = encodeParams(params, aesKey) // 对业务参数(params)进行加密
  result.key = createEncryptAesKey(serverPublicKey, aesKey) // 使用服务端公钥对aseKey进行加密
  result.secretKeyAesKey = createEncryptAesKey(logPublicKey, key, true) // 使用日志公钥对aseKey进行加密
  return result
}
